__turbopack_context__.v({
  "active": "GovTradesTabs-module-scss-module__IvoRXq__active",
  "tab": "GovTradesTabs-module-scss-module__IvoRXq__tab",
  "tabs": "GovTradesTabs-module-scss-module__IvoRXq__tabs",
});
